"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowDateEdit_1 = require("../../../../../../../../shared/components/editors/CardRowDateEdit");
var CardRowTimeEdit_1 = require("../../../../../../../../shared/components/editors/CardRowTimeEdit");
var PlayerBonusEdit = /** @class */ (function (_super) {
    __extends(PlayerBonusEdit, _super);
    function PlayerBonusEdit(props) {
        return _super.call(this, props) || this;
    }
    PlayerBonusEdit.prototype.componentWillMount = function () {
        this.setState({
            title: this.props.record.title,
            description: this.props.record.description,
            is_will_expire: this.props.record.is_bonus_has_ttl,
            expire_to_year: this.props.record.date_to_expire.get('year'),
            expire_to_month: this.props.record.date_to_expire.get('month') + 1,
            expire_to_day: this.props.record.date_to_expire.get('date'),
            expire_to_hour: this.props.record.date_to_expire.get('hour'),
            expire_to_minute: this.props.record.date_to_expire.get('minute'),
            expire_to_second: this.props.record.date_to_expire.get('second'),
        });
        this.doReSetRules();
    };
    PlayerBonusEdit.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false }
        });
    };
    PlayerBonusEdit.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        return true;
    };
    PlayerBonusEdit.prototype.OnEditDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                title: this.state.title,
                description: this.state.description,
                is_will_expire: this.state.is_will_expire,
                expire_to_year: this.state.expire_to_year,
                expire_to_month: this.state.expire_to_month,
                expire_to_day: this.state.expire_to_day,
                expire_to_hour: this.state.expire_to_hour,
                expire_to_minute: this.state.expire_to_minute,
                expire_to_second: this.state.expire_to_second,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Бонус изменен!");
            });
        }
    };
    PlayerBonusEdit.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerBonusEdit.prototype.getFormTitle = function () {
        return "Изменить бонус";
    };
    PlayerBonusEdit.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 420 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название бонуса" }, value: this.state.title, onValueChanged: function (newVal) { _this.setState({ title: newVal }); }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание бонуса" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Дата окончания бонуса", value: this.state.is_will_expire, onChecked: function (checked) { _this.setState({ is_will_expire: checked }); } }),
            React.createElement(CardRowDateEdit_1.default, { texts: { caption: "Дата окончания", placeholder: "Дата окончания бонуса" }, value: {
                    day: this.state.expire_to_day,
                    month: this.state.expire_to_month,
                    year: this.state.expire_to_year
                }, onValueChanged: function (year, month, day) {
                    _this.setState({
                        expire_to_day: day,
                        expire_to_month: month,
                        expire_to_year: year
                    });
                }, disabled: !this.state.is_will_expire }),
            React.createElement(CardRowTimeEdit_1.default, { texts: { caption: "Время окончания", placeholder: "Время окончания бонуса" }, value: {
                    hour: this.state.expire_to_hour,
                    minute: this.state.expire_to_minute,
                    second: this.state.expire_to_second
                }, onValueChanged: function (hour, minute, second) {
                    _this.setState({
                        expire_to_hour: hour,
                        expire_to_minute: minute,
                        expire_to_second: second
                    });
                }, disabled: !this.state.is_will_expire }),
            React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: function () { }, onEditClick: this.OnEditDataClick.bind(this) })));
    };
    return PlayerBonusEdit;
}(React.Component));
exports.default = PlayerBonusEdit;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/bonuses/PlayerBonusEdit.tsx
// module id = 1932
// module chunks = 0